import styled, { keyframes } from 'styled-components';
import { useState, useCallback, createElement, Fragment, createContext, useContext } from 'react';
import { createPortal } from 'react-dom';
import { CloseIcon } from '@tinacms/icons';
import { TinaReset, Button } from '@tinacms/styles';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-end;\n  border-radius: 0 0 5px 5px;\n  padding: 0 var(--tina-padding-big) var(--tina-padding-big)\n    var(--tina-padding-big);\n  ", " {\n    flex: 0 1 auto;\n    min-width: 128px;\n    margin: 0 var(--tina-padding-small) 0 0;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: ", ";\n  margin: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 160px;\n\n  &:last-child {\n    border-radius: 0 0 5px 5px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 var(--tina-padding-big) 0 var(--tina-padding-big);\n  border-bottom: 1px solid var(--tina-color-grey-3);\n  margin: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  fill: var(--tina-color-grey-5);\n  cursor: pointer;\n  transition: fill 85ms ease-out;\n  svg {\n    width: 24px;\n    height: auto;\n  }\n  &:hover {\n    fill: var(--tina-color-grey-8);\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: var(--tina-font-size-4);\n  font-weight: var(--tina-font-weight-regular);\n  line-height: normal;\n  margin: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  overflow: auto;\n  padding: 0;\n  z-index: var(--tina-z-index-3);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ModalProvider = function ModalProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      modalRootContainerRef = _useState[0],
      setModalRootContainerRef = _useState[1];

  var setModalRef = useCallback(function (node) {
    if (node !== null) {
      setModalRootContainerRef(node);
    }
  }, []);
  return createElement(Fragment, null, createElement("div", {
    id: "modal-root",
    ref: setModalRef
  }), createElement(ModalContainerContext.Provider, {
    value: {
      portalNode: modalRootContainerRef
    }
  }, children));
};

var ModalContainerContext = /*#__PURE__*/createContext(null);

function useModalContainer() {
  var modalContainer = useContext(ModalContainerContext);

  if (!modalContainer) {
    throw new Error('No Modal Container context provided');
  }

  return modalContainer;
}

var Modal = function Modal(_ref2) {
  var props = _extends({}, _ref2);

  var _useModalContainer = useModalContainer(),
      portalNode = _useModalContainer.portalNode;

  return portalNode && portalNode ? createPortal(createElement(TinaReset, null, createElement(ModalOverlay, null, createElement("div", Object.assign({}, props)))), portalNode) : null;
};

var ModalOverlay = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject());
var ModalTitle = /*#__PURE__*/styled.h2( /*#__PURE__*/_templateObject2());
var CloseButton = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3());
var ModalHeader = /*#__PURE__*/styled(function (_ref3) {
  var children = _ref3.children,
      close = _ref3.close,
      styleProps = _objectWithoutPropertiesLoose(_ref3, ["children", "close"]);

  return createElement("div", Object.assign({}, styleProps), createElement(ModalTitle, null, children), close && createElement(CloseButton, {
    onClick: close
  }, createElement(CloseIcon, null)));
})( /*#__PURE__*/_templateObject4());
var ModalBody = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject5(), function (p) {
  return p.padded ? 'var(--tina-padding-big)' : '0';
});
var ModalActions = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject6(), Button);

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  z-index: var(--tina-z-index-0);\n  overflow: visible;\n  background-color: #fff;\n  border-radius: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: calc(100% - 170px);\n  max-width: 1500px;\n  height: 100%;\n  animation: ", " 150ms ease-out 1;\n\n  ", " {\n    flex: 1 0 auto;\n    display: flex;\n    flex-direction: column;\n  }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  0% {\n    transform: translate3d( -2rem, 0, 0 );\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d( 0, 0, 0 );\n    opacity: 1;\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var ModalFullscreenKeyframes = /*#__PURE__*/keyframes( /*#__PURE__*/_templateObject$1());
var ModalFullscreen = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$1(), ModalFullscreenKeyframes, ModalBody);

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  z-index: var(--tina-z-index-0);\n  overflow: visible; /* Keep this as \"visible\", select component needs to overflow */\n  background-color: var(--tina-color-grey-1);\n  border-radius: var(--tina-radius-small);\n  margin: 40px auto;\n  width: 460px;\n  max-width: 90%;\n  animation: ", " 150ms ease-out 1;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  0% {\n    transform: translate3d( 0, -2rem, 0 );\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d( 0, 0, 0 );\n    opacity: 1;\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var ModalPopupKeyframes = /*#__PURE__*/keyframes( /*#__PURE__*/_templateObject$2());
var ModalPopup = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$2(), ModalPopupKeyframes);
export { Modal, ModalActions, ModalBody, ModalFullscreen, ModalHeader, ModalOverlay, ModalPopup, ModalProvider, useModalContainer };